import "../App.css";
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

function BackToHome () {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;
        const handleMouseMove = () => {
            setVisible(true); 
            clearTimeout(timeoutId); 
            timeoutId = setTimeout(() => { setVisible(false);}, 1000);
        };
        window.addEventListener("mousemove", handleMouseMove);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            clearTimeout(timeoutId);
        };
    }, []);
    
    return (
        <button className='BackToHome' style={{ opacity: visible ? 1 : 0 }}>
        <Link to="/"> Home </Link>
        </button>
    )
}

export default BackToHome;